module.exports = __webpack_public_path__ + "img/hopkins-tall.90bfb7bc.png";